import { render, staticRenderFns } from "./KisDefectList.vue?vue&type=template&id=0e2e1d38"
import script from "./KisDefectList.js?vue&type=script&lang=js&external"
export * from "./KisDefectList.js?vue&type=script&lang=js&external"
import style0 from "./KisDefectList.vue?vue&type=style&index=0&id=0e2e1d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports